import gql from 'graphql-tag';

export const GET_LIST_OF_PACCAR_CAB_TYPES = gql`
  query GetListOfPacCarCabTypes {
    paccarCabTypes {
      name
      type
      paccarCode
    }
  }
`;
